import { useState } from 'react';
import { detectTheme } from './themeStorage';

export function useTheme() {
  const [themeState, setThemeState] = useState(() => detectTheme());

  return {
    theme: themeState.theme,
    setTheme: (newTheme) => {
      setThemeState({ theme: newTheme, hasExplicitPref: true });
    }
  };
}

export function usePalette(theme) {
  if (theme === "dark") {
    return {
      rootBg:
        "min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-indigo-950 text-white",
      rootText: "text-white",
      header:
        "sticky top-0 z-40 border-b border-blue-800 bg-indigo-950/80 backdrop-blur",
      headerTitle: "text-white",
      navLinkActive: "bg-white text-blue-900",
      navLinkIdle: "ring-1 ring-blue-300 text-white hover:bg-blue-800",
      breadcrumbLink: "hover:text-white text-blue-200",
      breadcrumbCurrent: "text-white",
      hero: "border-b border-blue-800 bg-gradient-to-br from-blue-950 via-blue-900 to-blue-800",
      paragraph: "text-blue-100",
      card: "rounded-2xl border border-blue-800 bg-blue-900 p-6 shadow-sm",
      cardTitle: "text-white",
      cardP: "text-blue-100",
      chip: "rounded-xl bg-blue-800 text-white px-3 py-1.5 text-sm hover:bg-blue-700",
      ctaPrimary:
        "rounded-2xl bg-white text-blue-900 px-4 py-2 text-sm font-semibold shadow hover:bg-gray-100",
      ctaSecondary:
        "rounded-2xl bg-blue-800 text-white px-4 py-2 text-sm font-semibold shadow hover:bg-blue-700",
      footer: "mt-16 border-t border-blue-800 bg-blue-950",
      formContainer: "bg-blue-900/70 ring-1 ring-blue-700",
      formInput: "border border-blue-700 bg-blue-950/50 text-white placeholder:text-blue-300",
      formButtonActive: "bg-white text-blue-900",
      formButtonIdle: "bg-blue-950/50 ring-1 ring-blue-700 text-white",
      formText: "text-blue-300",
      successMessage: "bg-green-900/30 border-green-700 text-green-200",
      errorMessage: "bg-red-900/30 border-red-700 text-red-200",
    };
  }
  return {
    rootBg:
      "min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-100 text-gray-900",
    rootText: "text-gray-900",
    header:
      "sticky top-0 z-40 border-b border-indigo-200 bg-white/80 backdrop-blur",
    headerTitle: "text-indigo-900",
    navLinkActive: "bg-indigo-600 text-white",
    navLinkIdle: "ring-1 ring-indigo-200 text-indigo-700 hover:bg-indigo-50",
    breadcrumbLink: "hover:text-indigo-800 text-indigo-600",
    breadcrumbCurrent: "text-indigo-900",
    hero: "border-b border-indigo-200 bg-gradient-to-br from-blue-50 via-white to-indigo-100",
    paragraph: "text-gray-700",
    card: "rounded-2xl border border-indigo-200 bg-indigo-50 p-6 shadow-sm",
    cardTitle: "text-indigo-900",
    cardP: "text-gray-700",
    chip:
      "rounded-xl bg-indigo-100 text-indigo-800 px-3 py-1.5 text-sm hover:bg-indigo-200",
    chipAlt:
      "rounded-xl bg-white text-indigo-700 ring-1 ring-indigo-600 px-3 py-1.5 text-sm font-semibold shadow hover:bg-indigo-50",
    ctaPrimary:
      "rounded-2xl bg-indigo-600 text-white px-4 py-2 text-sm font-semibold shadow hover:bg-indigo-700",
    ctaSecondary:
      "rounded-2xl bg-white text-indigo-700 ring-1 ring-indigo-600 px-4 py-2 text-sm font-semibold shadow hover:bg-indigo-50",
    footer: "mt-16 border-t border-indigo-200 bg-white",
    formContainer: "bg-white/70 ring-1 ring-indigo-200",
    formInput: "border border-indigo-200 bg-indigo-50 text-gray-900",
    formButtonActive: "bg-indigo-600 text-white",
    formButtonIdle: "bg-white ring-1 ring-indigo-200 text-gray-900",
    formText: "text-gray-500",
    successMessage: "bg-emerald-50 border-emerald-300 text-emerald-800",
    errorMessage: "bg-rose-50 border-rose-300 text-rose-800",
  };
}
